import { z } from "zod";
import {
  DocumentMetaTs,
  ImageTs,
  LocaleTs,
} from "../../common";
import { BecomePartnerSchema, ContactUsSchema, CustomsSchema, FooterAboutUsNavigationSchema, FooterShopsNavigationSchema, FooterTravelersNavigationSchema, NewsletterSmallSchema, ShippingNavigationSchema } from "../components/footer.component";
import { OmitDocumentMeta } from "@/providers/strapi/client/types";
import { SingleTypes } from "..";
import { useContext } from "react";
import { ContentContext } from "../../content-provider";




export type Footer = z.output<typeof FooterTs>;

export const FooterTs = DocumentMetaTs.extend({
  id: z.int(),
  locale: LocaleTs,
  localizations: z.array(DocumentMetaTs),
  downloadZapptax: z.string(),
  appStoreImage: ImageTs,
  playStoreImage: ImageTs,
  travelersNavigation: FooterTravelersNavigationSchema,
  shopsNavigation: FooterShopsNavigationSchema,
  shippingNavigation: ShippingNavigationSchema,
  aboutUsNavigation: FooterAboutUsNavigationSchema,
  termsAndConditions: z.string(),
  privacyPolicy: z.string(),
  contactUsTraveler: ContactUsSchema,
  customs: CustomsSchema,
  newsletter: NewsletterSmallSchema,
  contactUsRetailer: ContactUsSchema,
  becomePartner: BecomePartnerSchema,
  legal: z.string(),
  wechatModalMessage: z.string()
})

export const FOOTER = 'footer'
export function useFooter<
  K extends keyof Omit<Footer, "id" | "locale" | "localizations" | OmitDocumentMeta>
>(
  entity?: K
): Footer[K] | Footer {
  const content: Record<string, SingleTypes> | null = useContext(ContentContext);
  if (!content) throw new Error(`Header content not found`)
  const header = content[FOOTER] as Footer;
  if (!header || (entity && !header[entity])) throw new Error(`${entity} content not found`)
  return entity ? header[entity] : header;
}
